export default __webpack_public_path__ + "static/media/icons8-mongodb.03ea0227.png";